import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { SecureStorage } from '../common-services/SecureStorage.service';

@Injectable({
  providedIn: 'root'
})
export class ThemesService {

  public themeLogoVariable: string;
  public currencyType:string;

  constructor(
    @Inject(DOCUMENT) private document: HTMLDocument,
    private secureStorage: SecureStorage,
  ) {
  }

  themeInitializer() {
    var clientName = localStorage.getItem("Theme");
    //var clientName = 'afx';
      if(clientName != null && clientName != undefined){
        // var path = 'assets/css/'+ clientName +'.css';
        // var imagePath = 'assets/images/'+ clientName +'/favicon.ico'
        var path = 'assets/css/'+ clientName +'.css?ver=' + new Date().getTime() + '.0';
        var imagePath = 'assets/images/'+ clientName +'/favicon.ico?ver=' + new Date().getTime() + '.0';
        this.document.getElementById('appStyle').setAttribute('type', 'text/css');
        this.document.getElementById('appStyle').setAttribute('href', path);
        this.document.getElementById('appFavicon').setAttribute('href', imagePath);
      }
      else{
        this.document.getElementById('appStyle').setAttribute('href', 'afx.css');
        this.document.getElementById('appFavicon').setAttribute('href', 'assets/images/afx/favicon.ico');
      }
  }
  loadStyle(styleName: string) {
    // var clientName = localStorage.getItem("Theme");
    // this.document.getElementById('appStyle').setAttribute('href', 'Booking-Widget/src/assets/css/'+ clientName +'.css?ver=' + new Date().getTime() + '.0')

    this.document.getElementById('appStyle').setAttribute('type', 'text/css');
    this.document.getElementById('appStyle').setAttribute('href', 'afx.css');
    var clientName = localStorage.getItem("Theme");
    this.document.getElementById('appStyle').setAttribute('type', 'text/css');
    this.document.getElementById('appStyle').setAttribute('href', 'afx.css');
  }
}
